import { all } from "redux-saga/effects";

import auth from "./auth";
import clientSagas from "./client";
import tiltviewSagas from "../redux/TiltView/saga";
import data360LiveViewsSaga from "../redux/d360Live_Views/saga";
import data360LiveSlogSaga from "../redux/data360LiveSlog/saga";
import data360LiveTlogSaga from "../redux/data360LiveTlog/saga";
import data360LivePqrSagas from "../redux/data360Live_PQR/saga";
import data360LiveProjectSaga from "../redux/data360Live_Project/saga";
import data360LiveReportSaga from "../redux/data360Live_Report/saga";
import data360LiveStatusConfigSaga from "../redux/data360Live_StatusConfiguration/saga";
import data360LiveWeldParameterSaga from "../redux/data360Live_WeldParameter/saga";
import deviceIdSagas from "../redux/deviceRegister/saga";
import pqrdataSagas from "../redux/pqrReportData/saga";
import projectSaga from "../redux/project/saga";
import slogsReportSagas from "../redux/reportGenerator/saga";
import slogsSaga from "../redux/sLogdata/saga";
import statusSagas from "../redux/statusCalculation/saga";
import tlogsSaga from "../redux/tLogData/saga";
import zoneviewSaga from "../redux/zoneView/saga";

export default function* rootSaga() {
  yield all([
    clientSagas(),
    auth(),
    projectSaga(),
    slogsSaga(),
    zoneviewSaga(),
    tlogsSaga(),
    slogsReportSagas(),
    statusSagas(),
    pqrdataSagas(),
    tiltviewSagas(),
    deviceIdSagas(),
    data360LiveProjectSaga(),
    data360LiveSlogSaga(),
    data360LiveViewsSaga(),
    data360LiveTlogSaga(),
    data360LiveStatusConfigSaga(),
    data360LiveReportSaga(),
    data360LivePqrSagas(),
    data360LiveWeldParameterSaga(),
  ]);
}
